import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const filesList = (query) => axiosInstance.get('/appearance/files/list', { params: { ...pickDevParams, ...query } });
export const filesListPagination = (query) => axiosInstance.get('/appearance/files/list-pagination', { params: { ...pickDevParams, ...query } });
export const filesDelete = (id) => axiosInstance.post(`/appearance/files/delete/${id}`, { ...pickDevParams });
export const filesUpload = (file) => axiosInstance.post('/appearance/files/upload', file, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
